import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/base.scss'

import ApiPlugin from './api'
import DomPlugin from './dom'
import IconPlugin from './icons'
import ComponentPlugin from './components'
import StorePlugin from './store'

// Read config from page context
const cfg = (window._sl || {})['config'] || {}

Vue.use(DomPlugin)
Vue.use(IconPlugin)
Vue.use(ComponentPlugin)
Vue.use(ApiPlugin, cfg)
Vue.use(StorePlugin, cfg)

Vue.config.productionTip = false

new Vue({
  router,
  store: StorePlugin.store,
  render: h => h(App),
  async created () {
    const signedIn = await this.initialize()
    if (!signedIn) {
      this.$router.push('/login')
    }
  }
}).$mount('#shopping-list-app')
